import {getCustomValidationMessage} from '@/utils/customValidationMessages';

export const initFloatingInputs = () => {

	const wrappers = document.querySelectorAll('.js-floating-input');

	wrappers.forEach((wrapper) => {
		const input = wrapper.querySelector('input');
		const errorContainer = wrapper.querySelector('.error');

		input.addEventListener('input', (event) => {
			const inputHasText = event.target.value.length > 0;
			wrapper.classList.toggle('has-value', inputHasText);

			input.checkValidity();
			input.setCustomValidity(getCustomValidationMessage(input));

			if(wrapper.classList.contains('is-invalid') && input.validity.valid) {
				errorContainer.textContent = '';
				wrapper.classList.add('is-valid');
				wrapper.classList.remove('is-invalid');
			}
		});

		input.addEventListener('blur', () => {
			input.checkValidity();
			if (input.validity.valid) {
				errorContainer.textContent = '';
				wrapper.classList.add('is-valid');
				wrapper.classList.remove('is-invalid');
			} else {
				wrapper.classList.add('is-invalid');
				wrapper.classList.remove('is-valid');
				input.setCustomValidity(getCustomValidationMessage(input));
				errorContainer.textContent = input.validationMessage;
			}
		});

		wrapper.classList.toggle('has-value', input.value.length > 0);
		wrapper.classList.add('initted');
	});
};
